import React from 'react'
import moment from 'moment'
import { ReactComponent as TransfixLogo } from 'transfix-ui/components/LogoIcon/svgs/LogoIconSolid.svg'
import { Box, Typography } from 'transfix-ui/core'
import { capitalize } from 'utils/capitalize'
import FORMATS from 'constants/datetime'
import { ReactComponent as HighwayLogo } from './svgs/HighwayLogoIcon.svg'

interface IDataReportedBy {
  reporter: 'highway' | 'transfix'
  date?: string
}

export const DataReportedBy = ({ date, reporter }: IDataReportedBy) => (
  <Box display='grid' gridTemplateColumns='12px 1fr' gap='4px' alignItems='center' mt={0.5} mb={1}>
    <Box borderRadius='100%' height='12px' width='12px' display='flex' alignItems='center'>
      {reporter === 'highway' ? <HighwayLogo /> : <TransfixLogo />}
    </Box>
    <Typography variant='caption'>
      Data reported by {capitalize(reporter)}
      {!!date && <span> {moment(date).format(FORMATS.dateFormatShort)}</span>}
    </Typography>
  </Box>
)
